export default ['Asian', 'Black', 'Coloured', 'Indian', 'White', 'Other']
